// Ported from twifi-theme-html/src/scripts/helpers/wc-account-pi-toggle.js
//
// Drives the Personal Information tab's read/edit toggle (account.twig,
// #info-tab-content, is_user_can_change_personal_data == true branch): shows
// the read-only <dl> summary by default and reveals the edit <form> on
// "Edit" click, hiding it again on "Cancel". Purely client-side, no
// persistence — Cancel does not revert unsaved edits to their original
// values (matches the reference's own behavior). The edit trigger/form panel
// don't exist at all when editing is disabled (the false branch), so both
// are looked up defensively.
function initAccountPiToggle(root) {
    const trigger = root.querySelector('[data-wc-account-pi-edit-trigger]');
    const cancel = root.querySelector('[data-wc-account-pi-cancel]');
    const panels = root.querySelectorAll('[data-wc-account-pi-panel]');

    if (!trigger) {
        return;
    }

    function show(mode) {
        panels.forEach((panel) => {
            panel.hidden = panel.dataset.wcAccountPiPanel !== mode;
        });
        trigger.hidden = mode === 'edit';
        trigger.setAttribute('aria-expanded', String(mode === 'edit'));
    }

    trigger.addEventListener('click', () => show('edit'));
    cancel?.addEventListener('click', () => show('view'));
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-wc-account-pi-toggle]').forEach(initAccountPiToggle);
});
